import styled from 'styled-components/macro';
import { ImageStyled } from '@yme/atoms/image';
import { colorBlackTransparent300, HERO_SECTION_BACKGROUND_SECOND } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel2, HeadingLevel4 } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
export const CardsListCardStyled = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 492px;
  width: 100%;
  height: 100%;
  overflow-wrap: break-word;

  ${ADAPTIVE.minWidth.tablet} {
    min-height: 405px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    min-height: ${({ isLargeCard }) => (isLargeCard ? '576px' : '370px')};
  }
`;
export const ImageBgStyled = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: ${colorBlackTransparent300};

  ${ADAPTIVE.minWidth.tablet} {
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }

  ${ImageStyled} {
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;
export const ImageMaskStyled = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  background-color: ${colorBlackTransparent300};

  ${ADAPTIVE.minWidth.tablet} {
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }
`;
export const Title = styled(HeadingLevel2) `
  ${getTextStyles('Play', 700, 24, 28)}

  margin-bottom: 16px;
`;
export const FlexWrapperStyled = styled(FlexWrapper) `
  padding: 16px;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  z-index: ${Z_INDEX.level0};

  ${ADAPTIVE.minWidth.tablet} {
    padding: 24px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding-right: calc(50% - 24px);
  }
`;
export const Subtitle = styled(HeadingLevel4) `
  ${getTextStyles('Play', 700, 14, 16)}

  margin-bottom: 4px;
`;
